import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { PROCESS_FEATURE, StateUtils, StateWithProcess } from '@spartacus/core';

export function getProcessState<T>(): MemoizedSelector<StateWithProcess<T>, StateUtils.EntityLoaderState<T>> {
  return createFeatureSelector<StateUtils.EntityLoaderState<T>>(PROCESS_FEATURE);
}
